/* src/app/umbrella-common/dekra-logo/dekra-logo.component.scss */
.dekra-logo,
.dekra-link {
  height: 56px;
  cursor: pointer;
}
#without-label {
  width: 160px;
  height: auto;
  cursor: pointer;
}
@media screen and (max-width: 479px) {
  #without-label {
    width: 120px;
  }
}
/*# sourceMappingURL=dekra-logo.component.css.map */
